export const crewRoute = {
  base: '/crew',
  jobs: '/jobs',
  crm: '/crm',
  leads: '/leads',
  clients: '/clients',
  communication: '/communication',
  quotes: '/quotes',
  inventory: '/inventory',
  product: '/product',
  package: '/package',
  settings: '/settings',
  users: '/users',
  schedule: '/schedule',
  vehicles: '/vehicles',
  trucks: '/trucks',
  equipments: '/equipments',
  trailers: '/trailers',
  vendors: '/vendors',
  purchaseOrder: '/purchase-order',
  order: '/order',
  roleManagement: '/role-management',
  coupon: '/coupon',
  eventType: '/event-type',
  category: '/category',
  quarantines: '/quarantine',
  invoice: '/invoice',
  checklist: '/checklist',
  task: '/task',
  global: '/global',
  venue: '/venue',

  // Reports
  reports: '/reports',
  overbookingItem: '/overbooking-item',
  subrentalsReport: '/subrentals',
  quarantineReport: '/quarantine',
  foremanTaskReport: '/foreman-task-completion',
  clientIncomeReport: '/client-income',
  revenueReport: '/revenue',
  geographicRevenueReport: '/geographic-revenue',
  quoteRevenueReport: '/quote-revenue',
  orderRevenueReport: '/order-revenue',
  cancellationReport: '/cancellation',
  deliveryReport: '/delivery-pickup',
  taskCompletionReport: '/task-completion',
  discountUsageReport: '/discount-usage',
  featureUtilizationReport: '/feature-utilization',
  jobCostingReport: '/job-costing',
  inventoryUsageReport: '/inventory-usage',
  marketingRevenueReport: '/marketing-revenue',
  financialOrderReport: '/financial-order',
  transactionSummaryReport: '/transaction-summary',

  // Common
  commonCreate: '/create',
  commonEdit: '/edit',
  commonClone: '/clone',
  commonDetail: '/:id',
};

export const crewRouteVehicles = {
  vehicles: `${crewRoute.base}${crewRoute.vehicles}`,
};

export const crewRouteTrucks = {
  trucks: `${crewRoute.base}${crewRoute.vehicles}${crewRoute.trucks}`,
};

export const crewRouteEquipments = {
  equipments: `${crewRoute.base}${crewRoute.vehicles}${crewRoute.equipments}`,
};

export const crewRouteTrailers = {
  trailers: `${crewRoute.base}${crewRoute.vehicles}${crewRoute.trailers}`,
};

export const crewRouteVendors = {
  vendors: `${crewRoute.base}${crewRoute.vendors}`,
  detailVendor: `${crewRoute.base}${crewRoute.vendors}${crewRoute.commonDetail}`,
};

export const crewRoutePurchaseOrder = {
  purchaseOrder: `${crewRoute.base}${crewRoute.purchaseOrder}`,
  detailPurchaseOrder: (purchaseOrderId: string) => `${crewRoute.base}${crewRoute.purchaseOrder}/${purchaseOrderId}`,
};

export const crewRouteOrder = {
  order: `${crewRoute.base}${crewRoute.order}`,
  detailOrder: (orderId: string) => `${crewRoute.base}${crewRoute.order}/${orderId}`,
  updateOrder: (orderId: string) => `${crewRoute.base}${crewRoute.order}/${orderId}${crewRoute.commonEdit}`,
};

export const crewRouteCrm = {
  crm: `${crewRoute.base}${crewRoute.crm}`,
  leads: `${crewRoute.base}${crewRoute.crm}${crewRoute.leads}`,
  createLead: `${crewRoute.base}${crewRoute.crm}${crewRoute.leads}${crewRoute.commonCreate}`,
  detailLead: (leadId: string) => `${crewRoute.base}${crewRoute.crm}${crewRoute.leads}/${leadId}`,
  updateLead: (leadId: string) =>
    `${crewRoute.base}${crewRoute.crm}${crewRoute.leads}/${leadId}${crewRoute.commonEdit}`,
  clients: `${crewRoute.base}${crewRoute.crm}${crewRoute.clients}`,
  createClient: `${crewRoute.base}${crewRoute.crm}${crewRoute.clients}${crewRoute.commonCreate}`,
  detailClient: (clientId: string) => `${crewRoute.base}${crewRoute.crm}${crewRoute.clients}/${clientId}`,
  updateClient: (clientId: string) =>
    `${crewRoute.base}${crewRoute.crm}${crewRoute.clients}/${clientId}${crewRoute.commonEdit}`,
};

export const crewRouteQuote = {
  quotes: `${crewRoute.base}${crewRoute.quotes}`,
  createQuotes: `${crewRoute.base}${crewRoute.quotes}${crewRoute.commonCreate}`,
  detailQuote: (quoteId: string) => `${crewRoute.base}${crewRoute.quotes}/${quoteId}`,
  updateQuote: (quoteId: string) => `${crewRoute.base}${crewRoute.quotes}/${quoteId}${crewRoute.commonEdit}`,
};

export const crewRouteInventory = {
  inventories: `${crewRoute.base}${crewRoute.inventory}`,
  inventory: `${crewRoute.base}${crewRoute.inventory}${crewRoute.product}`,
  createInventory: `${crewRoute.base}${crewRoute.inventory}${crewRoute.product}${crewRoute.commonCreate}`,
  detailInventory: (inventoryId: string) =>
    `${crewRoute.base}${crewRoute.inventory}${crewRoute.product}/${inventoryId}`,
  updateInventory: (inventoryId: string) =>
    `${crewRoute.base}${crewRoute.inventory}${crewRoute.product}/${inventoryId}${crewRoute.commonEdit}`,
};

export const crewRoutePackage = {
  package: `${crewRoute.base}${crewRoute.inventory}${crewRoute.package}`,
  createPackage: `${crewRoute.base}${crewRoute.inventory}${crewRoute.package}${crewRoute.commonCreate}`,
  updatePackage: (packageId: string) =>
    `${crewRoute.base}${crewRoute.inventory}${crewRoute.package}/${packageId}${crewRoute.commonEdit}`,
  clonePackage: (packageId: string) =>
    `${crewRoute.base}${crewRoute.inventory}${crewRoute.package}/${packageId}${crewRoute.commonClone}`,
};

export const crewRouteUser = {
  users: `${crewRoute.base}${crewRoute.settings}${crewRoute.users}`,
  createUser: `${crewRoute.base}${crewRoute.settings}${crewRoute.users}${crewRoute.commonCreate}`,
  detailUser: (userId: string) => `${crewRoute.base}${crewRoute.settings}${crewRoute.users}/${userId}`,
  updateUser: (userId: string) =>
    `${crewRoute.base}${crewRoute.settings}${crewRoute.users}/${userId}${crewRoute.commonEdit}`,
};

export const crewRouteVenue = {
  venue: `${crewRoute.base}${crewRoute.settings}${crewRoute.venue}`,
  createVenue: `${crewRoute.base}${crewRoute.settings}${crewRoute.venue}${crewRoute.commonCreate}`,
  detailVenue: (venueId: string) => `${crewRoute.base}${crewRoute.settings}${crewRoute.venue}/${venueId}`,
  updateVenue: (venueId: string) =>
    `${crewRoute.base}${crewRoute.settings}${crewRoute.venue}/${venueId}${crewRoute.commonEdit}`,
};

export const crewRouteInvoice = {
  invoices: `${crewRoute.base}${crewRoute.invoice}`,
  createInvoice: `${crewRoute.base}${crewRoute.invoice}${crewRoute.commonCreate}`,
  updateInvoice: (invoiceId: string) => `${crewRoute.base}${crewRoute.invoice}/${invoiceId}${crewRoute.commonEdit}`,
};

export const crewRouteRoleManagement = {
  roleManagement: `${crewRoute.base}${crewRoute.settings}${crewRoute.roleManagement}`,
  createRole: `${crewRoute.base}${crewRoute.settings}${crewRoute.roleManagement}${crewRoute.commonCreate}`,
  updateRole: (roleId: string) =>
    `${crewRoute.base}${crewRoute.settings}${crewRoute.roleManagement}/${roleId}${crewRoute.commonEdit}`,
};

export const crewRouteRoleCoupon = {
  coupon: `${crewRoute.base}${crewRoute.settings}${crewRoute.coupon}`,
};

export const crewRouteRoleEventType = {
  eventType: `${crewRoute.base}${crewRoute.settings}${crewRoute.eventType}`,
};

export const crewRouteRoleCategory = {
  category: `${crewRoute.base}${crewRoute.settings}${crewRoute.category}`,
};

export const crewRouteRoleChecklist = {
  checklist: `${crewRoute.base}${crewRoute.settings}${crewRoute.checklist}`,
};

export const crewRouteJob = {
  jobs: `${crewRoute.base}${crewRoute.jobs}`,
  detailJob: (jobId: string) => `${crewRoute.base}${crewRoute.jobs}/${jobId}`,
};

export const crewRouteQuarantine = {
  quarantine: `${crewRoute.base}${crewRoute.inventory}${crewRoute.quarantines}`,
};

export const crewRouteTask = {
  task: `${crewRoute.base}${crewRoute.task}`,
};

export const crewRouteGlobal = {
  global: `${crewRoute.base}${crewRoute.global}`,
};

export const crewRouteReport = {
  reports: `${crewRoute.base}${crewRoute.reports}`,
  overbookingItem: `${crewRoute.base}${crewRoute.reports}${crewRoute.overbookingItem}`,
  subrentalsReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.subrentalsReport}`,
  clientIncomeReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.clientIncomeReport}`,
  revenueReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.revenueReport}`,
  geographicRevenueReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.geographicRevenueReport}`,
  quoteRevenueReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.quoteRevenueReport}`,
  orderRevenueReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.orderRevenueReport}`,
  cancellationReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.cancellationReport}`,
  deliveryReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.deliveryReport}`,
  taskCompletionReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.taskCompletionReport}`,
  discountUsageReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.discountUsageReport}`,
  featureUtilizationReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.featureUtilizationReport}`,
  jobCostingReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.jobCostingReport}`,
  inventoryUsageReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.inventoryUsageReport}`,
  quarantineReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.quarantineReport}`,
  foremanTaskReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.foremanTaskReport}`,
  marketingRevenueReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.marketingRevenueReport}`,
  financialOrderReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.financialOrderReport}`,
  transactionSummaryReport: `${crewRoute.base}${crewRoute.reports}${crewRoute.transactionSummaryReport}`,
};

export const crewRouteAbsolute = {
  // Dashboard
  dashboard: crewRoute.base,

  // Communication
  communication: `${crewRoute.base}${crewRoute.communication}`,

  // Settings
  settings: `${crewRoute.base}${crewRoute.settings}`,

  // Schedule
  schedule: `${crewRoute.base}${crewRoute.schedule}`,

  ...crewRouteVehicles,
  ...crewRouteTrucks,
  ...crewRouteEquipments,
  ...crewRouteTrailers,
  ...crewRouteVendors,
  ...crewRoutePurchaseOrder,
  ...crewRouteOrder,
  ...crewRouteCrm,
  ...crewRouteQuote,
  ...crewRouteInventory,
  ...crewRoutePackage,
  ...crewRouteUser,
  ...crewRouteVenue,
  ...crewRouteRoleManagement,
  ...crewRouteRoleCoupon,
  ...crewRouteRoleEventType,
  ...crewRouteRoleCategory,
  ...crewRouteRoleChecklist,
  ...crewRouteJob,
  ...crewRouteQuarantine,
  ...crewRouteInvoice,
  ...crewRouteReport,
  ...crewRouteTask,
  ...crewRouteGlobal,
};
